import { render } from "./Sidebar.vue?vue&type=template&id=1200aecc"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=1200aecc&lang=scss"

import exportComponent from "/Users/chrisrooster/Documents/Sites/mycelium/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__